import { combineReducers } from 'redux';
import siteSearchReducer from 'widgets/Sites/FindSite/provider/reducer';
import siteCountrySearchReducer from 'widgets/Sites/CountrySite/provider/reducer';
import { apiReducer } from 'react_api';

const rootReducers = combineReducers({
  theme_config: (state) => ({ ...state }),
  api: apiReducer,
  sites: siteSearchReducer,
  countrySites: siteCountrySearchReducer,
  trial: (state) => ({ ...state }),
  locale: (state) => ({ ...state }),
  lang_headers: (state) => ({ ...state, test_label: 'hello testing labels' }),
});

export default rootReducers;
